import styled from 'styled-components';
import { dimension, margin, image, border } from '../styleHelper2';

const Image = styled.img`
  ${dimension()}
  ${margin()}
  ${image()}
  ${border()}
`;

export default Image;
